import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { SimNaoPipe } from '../../pipes/sim-nao-pipe';
import { PlanoSaude } from '../plano-saude';
import { PlanoSaudeService } from '../plano-saude.service';

@Component({
  selector: 'app-plano-saude-list',
  templateUrl: './plano-saude-list.component.html',
  styleUrls: ['./plano-saude-list.component.css']
})
export class PlanoSaudeListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nome', 'ativoFormatado', 'internoFormatado', 'details'];

  constructor(private planoSaudeService: PlanoSaudeService, router: Router, dialog: MatDialog,
    private simNaoPipe: SimNaoPipe) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();
  }

  reloadData() {
    this.planoSaudeService.listarPlanoSaudeFiltroInativoOuInternoComProjecao(true, true)
      .subscribe(data => {
        // console.log(data)
        this.data = data as PlanoSaude[];

        this.data = this.configurarformatacoes(this.data);

        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.planoSaudeService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterPlanoSaude']);
  }

  details(id: number) {
    this.router.navigate(['manterPlanoSaude'], {
      state: {
        id: id,
        isUpdate: 'N'
      }
    });
  }

  update(id: number) {
    this.router.navigate(['manterPlanoSaude'], {
      state: {
        id: id,
        isUpdate: 'S'
      }
    });
  }

  configurarformatacoes(data: PlanoSaude[]) {
    data.forEach(
      (val, index) => {
        data[index].ativoFormatado = this.simNaoPipe.transform(data[index].ativo)
        data[index].internoFormatado = this.simNaoPipe.transform(data[index].interno)
      });

    return data;
  }

}
